/**
 * @param IDCard 1 身份证 
 * @param bank 2 银行卡 
 * @param license 3 营业执照
 * @param GATAndPassport 4 港澳台及护照
 * @param byHand 5 手持证件照（非大陆且无银联银行卡）
 */
export const certTypes = {
  IDCard: 1,
  GATAndPassport: 4,
  bank: 2,
  license: 3,
  byHand: 5
}
/** 非中国内陆用户标识 */
export const NonChinaLand = 309


// WEBPACK FOOTER //
// ./assets/js/utils/typesTool.js